export function getInitial(role: { name: string; userGroupName?: string }) {
    return `${role?.userGroupName?.[0] ?? role.name?.[0].toUpperCase?.() ?? ''}`;
}
